import {
  INFO_CONSOLE_TOGGLE,
  DIALOG_FULLSCREEN_OPEN,
  DIALOG_FULLSCREEN_CLOSE,
  MOBILE_WELCOME_ACKNOWLEDGE,
} from './ActionTypes';

import {getCurrentInvite} from '../selectors';
import getReadStatusKeyName from '../utils/getReadStatusKeyName.js';

import history from '../history.js';

export const toggleInfoConsole = () => {
  return dispatch => {
    dispatch({
      type: INFO_CONSOLE_TOGGLE
    });
  };
};

export const openFullscreenDialog = (props) => {
  return dispatch => {
    dispatch({
      type: DIALOG_FULLSCREEN_OPEN,
      payload: props
    });
  };
};

export const closeFullscreenDialog = () => {
  return dispatch => {
    dispatch({
      type: DIALOG_FULLSCREEN_CLOSE
    });
  };
};

export const acknowledgeMobileWelcome = () => {
  return (dispatch, getState) => {
    // If a user has scrolled down due to a long invite message then this is
    // needed to undo that scrolling.
    window.scrollTo(0, 0);

    const invite = getCurrentInvite(getState());
    const keyName = getReadStatusKeyName(invite);

    localStorage.setItem(keyName, new Date().toISOString());

    const fullscreenElement = document.fullscreenElement || document.webkitFullscreenElement || document.mozFullscreenElement || document.msFullscreenElement;

    if (!fullscreenElement) {
      const docEl = document.documentElement;
      const requestFullscreen = docEl.requestFullscreen || docEl.mozRequestFullScreen || docEl.webkitRequestFullScreen || docEl.msRequestFullscreen;

      if (requestFullscreen) {
        requestFullscreen.call(docEl);
      }
    }

    const currentURL = new URL(window.location.href);
    currentURL.searchParams.set('slideIndex', 0);
    history.replace(currentURL.pathname + currentURL.search);

    dispatch({
      type: MOBILE_WELCOME_ACKNOWLEDGE
    });
  };
};
